import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
// import { AgmCoreModule } from '@agm/core';
import { RouterModule, Routes } from '@angular/router';
import { FooterModule } from 'src/app/layout/footer/footer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BackdropModule } from 'src/app/share/components/backdrop/backdrop.module';
import { DirectivesModule } from 'src/app/share/directives/directives.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeGuard } from 'src/app/services/guards/home.guard';

const route: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [HomeGuard],
  },
];

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    DirectivesModule,
    BackdropModule,
    FooterModule,
    NgbDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(route),
  ],
  exports: [
    HomeComponent,
    // AgmCoreModule,
  ],
})
export class HomeModule {}
